import ApiConfig from "../config/Api.config";
import Data from "../data/Api.data";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";

const url: string = `${Data.URLS.urlApiSinergia}/usuario`

const login = async (username: string, password: string) => {    
    const request: Request = {
        url: `${url}/login`,
        method: "POST",
        data: { username, password },
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};


const UsuarioService = {
    login,
};

export default UsuarioService;